// extracted by mini-css-extract-plugin
export var carrierTab = "_4x-0";
export var carrierTabActive = "_4x-1 _4x-0";
export var carrierTabInactive = "_4x-2 _4x-0";
export var carrierTabLabel = "_4x-3";
export var carrierTabLabelActive = "_4x-4 _4x-3";
export var carrierTabLabelInactive = "_4x-5 _4x-3";
export var carrierTabPercentage = "_4x-6";
export var carrierTabPercentageActive = "_4x-7 _4x-6";
export var carrierTabPercentageInactive = "_4x-8 _4x-6";
export var carrierTabWinnable = "_4x-9";
export var carrierTabWinnableActive = "_4x-a _4x-9";
export var carrierTabWinnableInactive = "_4x-b _4x-9";
export var comparisonContainer = "_4x-d";
export var missingRateButton = "_4x-n";
export var missingRateButtonActive = "_4x-o _4x-n";
export var missingRateButtonInactive = "_4x-p _4x-n";
export var missingRateButtonLabel = "_4x-q";
export var missingRateButtonLabelActive = "_4x-r _4x-q";
export var missingRateButtonLabelInactive = "_4x-s _4x-q";
export var sidebar = "_4x-c";
export var strategyButton = "_4x-e";
export var strategyButtonActive = "_4x-f _4x-e";
export var strategyButtonDescription = "_4x-k";
export var strategyButtonDescriptionActive = "_4x-l _4x-k";
export var strategyButtonDescriptionInactive = "_4x-m _4x-k";
export var strategyButtonInactive = "_4x-g _4x-e";
export var strategyButtonLabel = "_4x-h";
export var strategyButtonLabelActive = "_4x-i _4x-h";
export var strategyButtonLabelInactive = "_4x-j _4x-h";
export var unitToggleButton = "_4x-t";
export var unitToggleButtonActive = "_4x-u _4x-t";
export var unitToggleButtonInactive = "_4x-v _4x-t";
export var unitToggleButtonLabel = "_4x-w";
export var unitToggleButtonLabelActive = "_4x-x _4x-w";
export var unitToggleButtonLabelInactive = "_4x-y _4x-w";